module.exports = __webpack_public_path__ + "static/media/sodexo.3bd63e3e.png";